import { colors } from '../constants/colors.js';
var multiselectThemeWeb = {
  color: 'primary',
  error: 'alert',
  borders: {
    radius: 'borders.radius',
    inactiveColor: colors.fogGrey
  }
};
export { multiselectThemeWeb };